import { FontEnum } from '@/constants/font'

const fonts = {
    bold: FontEnum.SatoshiBold,
    light: FontEnum.SatoshiLight,
    medium: FontEnum.SatoshiMedium,
    regular: FontEnum.SatoshiRegular,
} as const

export const lightTheme = {
    fonts,
} as const
